module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content grv"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35326a86","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/tasks/Main.vue
// module id = 1612
// module chunks = 17